import React from 'react'
import { Outlet } from 'react-router-dom'
import SnackbarNotification from '../components/SnackbarNotification'

const SnackbarNotificationContainer = () => {
  return (
    <>
      <Outlet/>
      <SnackbarNotification/>
    </>
  )
}

export default SnackbarNotificationContainer
